<template>
  <div class="modal-mask">
    <div class="modal-wrapper">
      <div
        class="modal-container"
        style="width: 50%;"
      >
        <!-- HEADER -->
        <div class="modal-header">
          <slot name="header">
            <h3 class="form-header">
              {{ editMode ? "Edit" : "Create" }} Sequence Event
            </h3>
            <button
              class="red-close-button"
              @click="closeModal"
            >
              <i class="pi pi-times"></i>
            </button>
          </slot>
        </div>
        <!-- BODY -->
        <div class="modal-body">
          <slot name="body">
            <div class="form-container">
              <div class="flex-input">
                <label for="event_name">Event Name</label>
                <InputText
                  id="event_name"
                  v-model="eventForm.name"
                  placeholder="Name"
                  class="grey-input"
                  required
                />
              </div>
              <div class="flex-input">
                <label for="event_value">Event Value</label>
                <InputText
                  id="event_value"
                  v-model="eventForm.value"
                  placeholder="Description"
                  class="grey-input"
                />
              </div>
              <div class="p-field">
                <Button
                  :label="actionButtonText"
                  :loading="loadingCreateEvent"
                  :disabled="loadingCreateEvent"
                  @click="editMode ? editSequenceEvent() : createSequenceEvent()"
                />
              </div>
            </div>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'AdminCreateEditSequenceEventModal',
  props: {
    /**
     * The selected campaigns
     * @type {Object}
     */
    sequenceEvent: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  emits: [
    'closeModal',
    'eventCreated',
    'eventEdited',
  ],
  data() {
    return {
      eventForm: {
        name: '',
        value: '',
      },
      loadingCreateEvent: false,
      createEditEventError: '',
      eventCreateEditSuccess: '',
      selectedTemplates: [],
      editMode: false,
      actionButtonText: 'Create',
    }
  },
  computed: {
    /**
     * Create Edit Recommended Sequence Payload
     * @returns {Object}
     */
    createEditSequenceEventPayload() {
      let payload = {
        name: this.eventForm.name,
        value: this.eventForm.value,
      }

      return payload;
    },
  },
  async mounted() {
    this.$store.dispatch('getRefreshToken');
      
    if (this.sequenceEvent && this.sequenceEvent.event_id) {
      this.editMode = true;
      this.actionButtonText = 'Update';

      this.eventForm.name = this.sequenceEvent.name;
      this.eventForm.value = this.sequenceEvent.value;
    }
  },
  methods: {
   /**
     * Create the sequence event
     */
    async createSequenceEvent() {
      this.loadingCreateSequence = true;
      this.$store.dispatch('getRefreshToken');
      this.createEditSequenceError = '';
      this.eventCreateEditSuccess = '';

      try {
        const res = await axios.post('/api/sequence-event/admin/create', this.createEditSequenceEventPayload, this.$store.state.header);
        this.handleCreateSequenceEventSuccess(res);
      } catch (err) {
        this.handleCreateSequenceEventError(this.handleAxiosError(err));
      }     
    },
    /**
     * Handle the success response from the create sequence event endpoint
     * @param {Object} res
     */
    handleCreateSequenceEventSuccess(res) {
      console.log('The create sequence event response is: ', res);
      this.loadingCreateEvent = false;
      this.eventCreateEditSuccess = 'Sequence Event Created Successfully';
      this.$emit('eventCreated', res.data);
      this.closeModal();
    },
    /**
     * Handle the error response from the create sequence event endpoint
     * @param {Object} err
     */
    handleCreateSequenceEventError(err) {
      console.log('The create sequence event error is: ', err);
      this.loadingCreateEvent = false;
      this.createEditEventError = err;
      this.eventCreateEditSuccess = '';
    },
    /**
     * Edit the sequence event
     */
    async editSequenceEvent() {
      this.loadingCreateEvent = true;
      this.$store.dispatch('getRefreshToken');
      this.createEditEventError = '';
      this.eventCreateEditSuccess = '';

      try {
        const res = await axios.post('/api/sequence-event/admin/' + this.sequenceEvent.event_id + '/edit', this.createEditSequenceEventPayload, this.$store.state.header);
        this.handleEditSequenceEventSuccess(res);
      } catch (err) {
        this.handleEditSequenceEventError(this.handleAxiosError(err));
      }
    },
    /**
     * Handle the success response from the edit sequence event endpoint
     * @param {Object} res
     */
    handleEditSequenceEventSuccess(res) {
      console.log('The edit sequence event response is: ', res);
      this.loadingCreateEvent = false;
      this.eventCreateEditSuccess = 'Sequence Event Edited Successfully';
      this.$emit('eventEdited', res.data);
      this.closeModal();
    },
    /**
     * Handle the error response from the edit sequence event endpoint
     * @param {Object} err
     */
    handleEditSequenceEventError(err) {
      console.log('The edit sequence event error is: ', err);
      this.loadingCreateEvent = false;
      this.createEditEventError = err;
      this.eventCreateEditSuccess = '';
    },
    /**
     * Clear the form
     */
    clear() {
      this.eventForm = {
        name: '',
        value: '',
      };
    },
    /**
     * Close the modal
     */
    closeModal() {
      this.$emit('closeModal');
    },
    /**
     * Close any open modals
     */
    closeOpenModals() {
      this.loadingCreateEvent = false;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/main.scss";

.modal-container {
  height: 78vh;
  display: flex;
  flex-direction: column;
}

.form-container {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 20px;
}

.flex-input {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: stretch;
  text-align: left;
}

.flex-input > label {
  font-size: 0.8rem;
}

.p-field-checkbox {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.form-row {
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: stretch;

  .span {
    display: flex;
  }
}

.flex-item {
  flex: 1;
}

.radio-group {
  gap: 0.5em;
}

.modal-body {
  padding-left: 40px !important;
  padding-right: 40px !important;
  padding-top: 2.5em;
  display: flex;
  flex-direction: column;
  flex: 1;
}

.modal-header {
  padding: 40px 40px 0 40px !important;
}

.form-header {
  color: black;
}

:deep(.p-accordion-header-link) {
  height: 4em;
  background: white;
  border: none;
  border-top: 1px solid $bordergrey;
}

:deep(.p-accordion-content) {
  border: none;
}

:deep(.p-accordion-content) p {
  margin: 0;
  font-size: 11pt;
  font-weight: 500;
  color: $deepgrey;
  font-family: Montserrat, Helvetica, Arial, sans-serif;
}

:deep(.p-calendar-w-btn .p-datepicker-trigger) {
  background: $strongblue;
}

.error-text {
  color: $error;
  margin: 0 auto 0 0;
  padding-left: 40px;
  font-weight: 600;
  font-size: 0.9rem;
  display: flex;
  font-weight: 600;
  text-align: left;
}

.red-error-icon {
  min-width: 20px;
  background-color: $error;
  border-color: $error;
  color: white;
  border-radius: 50% !important;
  height: 20px;
  width: 20px;
  margin: auto;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.error-text-span {
  margin: auto;
  padding-left: 10px;
}

.success-message {
  color: $complete;
  margin: 0 auto 0 0;
  padding-left: 40px;
  font-weight: 600;
  font-size: 0.9rem;
  display: flex;
  font-weight: 600;
  text-align: left;
}

</style>  